import { AccountType } from "component-library";
import { useQuery } from "react-query";
import { QueryKeys } from "../constants/QueryKeys";
import { navigationService } from "../services";

/**
 * Used to fetch navigation translations from Umbraco
 */
const useFetchNav = (locale: string) => {
  const { data, error, isLoading, isError } = useQuery(
    [QueryKeys.APP_NAV, locale],
    () =>
      navigationService.getAppNav({
        locale,
        userType: AccountType.DefaultUser,
      }),
    {
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );

  return { data, error, isLoading, isError };
};

export default useFetchNav;
